import { Entity } from '@backstage/catalog-model';

export const hasLinks = (entity: Entity) => {
  const links = entity?.metadata?.links;
  return Boolean(links && links.length > 0);
};
